import React, { useEffect } from "react";
import { Row, Col, Card } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { userStateSelector } from "../../../../../redux/reducers/user/userReducer";
import { onPage, sidebarNavigate } from "../../../../../redux/actions/app/appAction";
import { SideBarItems } from "../../../../constants/sideBarConstants";
import { Pages, jsonData } from "../../../../constants/constants";
import { getAppHeaderType } from "../../../../../utility/appUtil";
import { HeaderType } from "../../../../constants/enums";
import { useTranslation } from 'react-i18next';
import { CompWrapper } from "../../../stateless/common/compWrapper/compWrapper";
import './suggestedPrompts.less';

export const SuggestedPrompts = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { appUser } = useSelector(userStateSelector);

  useEffect(() => {
    dispatch(sidebarNavigate(SideBarItems.SUGGESTED_PROMPTS));
    if(appUser && getAppHeaderType(appUser) === HeaderType.JUNTO_PORTAL){
      dispatch(onPage({onComponent : Pages.ACCOUNT_SETTINGS}));
    } else {
      dispatch(onPage({onComponent : Pages.BIBLIOTHECA_ACCOUNT_SETTINGS}));
    }
  }, []);

  const promptCards = [
    {
      title: "Be clear and precise (when possible)",
      description: "The tool works best with specific prompts - e.g., \"How many items were borrowed at Central Branch last week?\" However, you can also ask open-ended questions like \"What footfall trends can you find between Q1 and Q2 2025 for all branches\""
    },
    {
      title: "Specify the branch and time period you're interested in",
      description: "Include specific branch names and time periods in your queries for more accurate and relevant results."
    },
    {
      title: "Use natural language",
      description: "Phrases like \"compare\", \"group by\", \"highlight trends\", work well - no technical jargon needed."
    },
    {
      title: "Do not include personal or sensitive information",
      description: "Avoid including names, contact details, or any personally identifiable information in your prompts."
    },
    {
      title: "State the desired output format",
      description: "The tool can create plain text summaries, tables, and even graphs."
    },
    {
      title: "Export your results",
      description: "Outputs can be exported for reports, presentations, or further analysis."
    },
    {
      title: "Iterate and refine",
      description: "Don't hesitate to follow up - \"Can you break that down by day of the week?\" or \"Now sort that by branch.\""
    }
  ];

  return (
    <div className="ml-23">
      {/* <Row className="accHed pl-vw">
        <Col>
          <span className="accSettHedLeft">Suggestions for effective Prompts</span>
        </Col>
      </Row> */}

      <CompWrapper otherClasses='suggestedPromptsPage'>
        <Row className="mt-29 pl-vw">
          <Col span={24}>
            <div className="suggested-prompts-container">
              <Card 
                className="single-prompt-card"
                title="Suggestions for effective Prompts"
                bordered={false}
              >
                <div className="prompts-list">
                  {promptCards.map((card, index) => (
                    <div key={index} className="prompt-item">
                      <h4 className="prompt-title">• {card.title}</h4>
                      <p className="prompt-description">{card.description}</p>
                    </div>
                  ))}
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </CompWrapper>
    </div>
  );
};
